// SAFE-WRITE-BEGIN: frontend/src/pages/valuation/_SnapshotDownload.tsx
/** VAL-SNAPSHOT-2: the owner's paid Snapshot download (shown only once the grant exists). */
import { useState } from 'react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { downloadSnapshot } from '@/api/valuationB3'
import { formatApiError } from '@/utils/httpErrors'

export function SnapshotDownloadButton({ engagementId }: { engagementId: string }) {
  const [busy, setBusy] = useState(false)

  async function onClick() {
    setBusy(true)
    try {
      const { blob, filename } = await downloadSnapshot(engagementId)
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      URL.revokeObjectURL(url)
    } catch (err) {
      toast.error(formatApiError(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <Button className="w-full" disabled={busy} onClick={onClick}>
      Download snapshot
    </Button>
  )
}
// SAFE-WRITE-EOF: frontend/src/pages/valuation/_SnapshotDownload.tsx
